import { render, staticRenderFns } from "./titlebar.vue?vue&type=template&id=ac981320"
import script from "./titlebar.vue?vue&type=script&lang=js"
export * from "./titlebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports